import styled from 'styled-components';
import {Checkbox as CheckboxComponent} from '@guestapp/old-ui-kit';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
`;

export const Checkbox = styled(CheckboxComponent)`
  align-items: start;

  & .checkbox__label {
    font-size: 14px;
    font-weight: 400;
  }

  & ~ .error-message {
    left: 7%;
    text-align: left;
    top: 45px;
  }

  @media (min-width: 396px) {
    & ~ .error-message {
      top: 22px;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  & .error-message {
    position: initial;
    margin-left: 35px;
  }
`;

export const OptionalLabel = styled.span`
  font-size: 14px;
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  font-style: italic;
`;
